// src/features/system/orchestrator/api/handlersV2Api.ts
import { bff } from '@/lib/http/bff';

export type HandlerSpecRow = {
  handler_key: string;
  version?: number;
  worker_key?: string;
  handler_namespace?: string;
  handler_key_base?: string;
  is_active?: boolean;
  updated_at?: string;
  description?: string;
  timeout_sec?: number;
  max_retries?: number;
  backoff_ms?: number;
  priority?: number;
  tags?: string[];
  io?: {
    inputs?: Array<{
      key: string;
      required?: boolean;
      type?: string;
      description?: string;
      default?: unknown;
    }>;
    outputs?: Array<{
      key: string;
      type?: string;
      description?: string;
    }>;
  };
  config?: unknown;
};

export interface ListHandlersV2Response {
  as_of?: string;
  items: HandlerSpecRow[];
  next_cursor?: string | null;
}

export interface ListHandlersV2Params {
  limit?: number;
  cursor?: string;
  tenant_id?: number;
  // Escape hatch if the workflow saves a different outcome_key.
  outcome_key?: string;

  // When true, return all handler versions (useful for workflow builder to resolve pinned :vN).
  all_versions?: boolean;

  // Escape hatch for debugging only. Default behavior is outcomes-only.
  // When true, merges classic handler-registry rows as a fallback.
  registry_fallback?: boolean;
}

export const fetchHandlersV2Api = (params: ListHandlersV2Params = {}): Promise<ListHandlersV2Response> =>
  bff.get<ListHandlersV2Response>('/orchestrator/handlers/v2', params as any);
